window.addEventListener('OpusCartChange', (event)=>{
    const shadowRoot = document.getElementById('opus-shadow-container')?.shadowRoot;
    const iconReward = shadowRoot.querySelectorAll(".cd-icon-inner");
    if (iconReward.length > 0) {
      iconReward.forEach((el, i) => {
        if (i === 0 || i === 2) {
          el.innerHTML = '<img style="width: 20px; height: 20px; margin-bottom: 4px; " src="https://cdn.shopify.com/s/files/1/0907/9269/0011/files/sublimae_gift.png?v=1744311376" alt="icon">'
        }
      })
    }
});